import { Avatar, Badge, styled } from "@mui/material";
import { Contact } from "../models/Contact";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: 2,
    top: 2,
    border: `1px solid ${theme.palette.background.paper}`,
    padding: "0 2px",
  },
}));

interface UserStatusIndicatorProps {
  contact: Contact;
  showUnread?: boolean;
}

export const UserStatusIndicator = ({
  contact,
  showUnread = true,
}: UserStatusIndicatorProps) => {
  return (
    <StyledBadge
      color={contact.status === "online" ? "success" : "default"}
      variant={contact.status === "online" ? "dot" : "standard"}
      badgeContent={showUnread && contact.unread > 0 ? contact.unread : null}
    >
      <Avatar
        alt={contact.name}
        src={contact.avatar}
        sx={{
          bgcolor: contact.isGroup ? "secondary.main" : "primary.main",
        }}
      >
        {!contact.avatar && contact.name.charAt(0)}
      </Avatar>
    </StyledBadge>
  );
};
